import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const SpravciOsobnichUdaju = {
	name: NAME,
	apiProvider,
	router,
};
